import axios from 'axios'
import { HashMap } from 'common/types'

export const get = async (url: string, params: HashMap = {}) => {
  // console.log('api', url)
  return axios
    .create({
      responseType: 'json',
      baseURL: 'https://bosai-api.riskma.jp/bosai'
      // baseURL: 'https://sl3mgfgby8.execute-api.ap-northeast-1.amazonaws.com/dev/bosai'
    })
    .get(url, {
      params
    })
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.error(err)
      return null
    })
}
